// Date display helpers. Horus stores instants in UTC; people read them in
// Europe/Istanbul, whatever the browser's own time zone is. Use these
// instead of toLocaleDateString(), which follows the browser.

export const TIME_ZONE = "Europe/Istanbul";

const dateFmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: TIME_ZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
});

const weekdayDateFmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: TIME_ZONE,
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
});

const dateTimeFmt = new Intl.DateTimeFormat("en-GB", {
    timeZone: TIME_ZONE,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
});

// en-CA formats as YYYY-MM-DD, the value format of <input type="date">.
const isoDateFmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
});

const toDate = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const d = value instanceof Date ? value : new Date(value);
    return isNaN(d.getTime()) ? null : d;
};

// formatDate("2026-10-11T22:30:00Z") -> "12 Oct 2026" (the Istanbul date).
// Pass { weekday: true } for "Mon, 12 Oct 2026". Returns fallback for
// empty or invalid input.
export const formatDate = (value, { weekday = false, fallback = "" } = {}) => {
    const d = toDate(value);
    if (!d) return fallback;
    return (weekday ? weekdayDateFmt : dateFmt).format(d);
};

// formatDateTime("2026-10-11T22:30:00Z") -> "12 Oct 2026, 01:30".
export const formatDateTime = (value, { fallback = "" } = {}) => {
    const d = toDate(value);
    if (!d) return fallback;
    return dateTimeFmt.format(d);
};

// toISODate(value) -> "2026-10-12": the Istanbul calendar date, in the
// format <input type="date"> expects.
export const toISODate = (value) => {
    const d = toDate(value);
    return d ? isoDateFmt.format(d) : "";
};

// todayISO() -> today's Istanbul date as YYYY-MM-DD (not the UTC date,
// which lags by a day between 00:00 and 03:00 in Istanbul).
export const todayISO = () => toISODate(new Date());
